// This file is automatically generated. DO NOT EDIT.

import { type RankingResult } from '../../../../types/response/RankingResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetRankingResultsResponse {
  /** The ranking results */
  results: Array<RankingResult>;
}

export async function getRankingResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetRankingResultsResponse>,
): Promise<GetRankingResultsResponse> {
  return getJSONResponse<GetRankingResultsResponse>(
    response,
    'getRankingResultsResponse',
    options,
  );
}
